import { render, staticRenderFns } from "./downLoad.vue?vue&type=template&id=7842c036&scoped=true&"
import script from "./downLoad.vue?vue&type=script&lang=js&"
export * from "./downLoad.vue?vue&type=script&lang=js&"
import style0 from "./downLoad.vue?vue&type=style&index=0&id=7842c036&lang=scss&scoped=true&"
import style1 from "./downLoad.vue?vue&type=style&index=1&id=7842c036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7842c036",
  null
  
)

export default component.exports